<script lang="ts">
  // Sticky relative-period label of the first visible row (spec §9 item 1).
  let { label }: { label: string } = $props();
</script>

<div class="datesep" aria-hidden="true">{label}</div>

<style>
  /* @css list/DateSep start */
  .datesep {
    position: sticky;
    top: 0;
    z-index: var(--z-sticky);
    padding: var(--space-1) var(--space-4);
    font-size: var(--text-xs);
    color: var(--text-muted);
    background: color-mix(in srgb, var(--surface-page) 88%, transparent);
    backdrop-filter: blur(6px);
    border-bottom: 1px solid var(--border-subtle);
    pointer-events: none
  }

  .datesep {
    block-size: var(--datesep-h);
    margin-block-start: calc(-1 * var(--datesep-h))
  }
  /* @css list/DateSep end */
</style>
